import { render, staticRenderFns } from "./NotPaidTeacherStudentsPage.vue?vue&type=template&id=7b98eb42&scoped=true&"
import script from "./NotPaidTeacherStudentsPage.vue?vue&type=script&lang=js&"
export * from "./NotPaidTeacherStudentsPage.vue?vue&type=script&lang=js&"
import style0 from "./NotPaidTeacherStudentsPage.vue?vue&type=style&index=0&id=7b98eb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b98eb42",
  null
  
)

export default component.exports